import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import Button2 from 'components/buttons/Button2/Button2';
import { AccountsContext } from '../../contexts/AccountsContext';
import styles from './style.cssmodule.css';

function NoResults() {
  const { dispatchFilters } = useContext(AccountsContext);
  const { formatMessage: t } = useIntl();

  return (
    <div className={styles.noResultsWrapper}>
      <div className={styles.noResultsContainer}>
        <div className={styles.noResultsTitle}>{t({ id: 'table.noResultFound.title' })}</div>
        <div className={styles.noResultsSubtitle}>{t({ id: 'table.noResultFound.subtitle' })}</div>
        <Button2 className={styles.noResultsButton} onClick={() => dispatchFilters({ type: 'RESET_FILTERS' })}>
          {t({ id: 'button.resetFilters' })}
        </Button2>
      </div>
    </div>
  );
}

export default NoResults;



// WEBPACK FOOTER //
// ./routes/cpm/routes/accounts/components/NoResults/NoResults.jsx